import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorLineChart = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      d="M20.119 5.452a.748.748 0 0 0-.294-.155l-3.189-.854a.75.75 0 1 0-.388 1.449l1.748.468-3.84 2.688-.963-.964A.75.75 0 0 0 12.23 8l-6.367 4.49a.75.75 0 0 0 .864 1.226l5.852-4.126.962.962a.75.75 0 0 0 .96.084l5.636-3.944a.75.75 0 0 0-.018-1.241Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="M22.5 21.962a.75.75 0 1 0 0-1.5h-2.603v-9.309a.75.75 0 1 0-1.5 0v9.309H14.31v-4.838a.75.75 0 1 0-1.5 0v4.838H8.72v-4.838a.75.75 0 1 0-1.5 0v4.838H4.25V4.447a.75.75 0 0 0-1.5 0v16.765c0 .414.336.75.75.75h19Z"
    />
  </svg>
);
export default SvgTwoColorLineChart;
